export const MYPAGE_ROUTES = {
  root: '/mypage',
  profile: '/mypage/profile',
  /** 내국인 개인 정보 변경 (PASS 본인인증). 사이드바 없는 단독 화면. */
  profileVerify: '/mypage/profile/verify',
  /** 외국인 휴대전화 변경 (SMS 인증). 사이드바 없는 단독 화면. */
  profilePhone: '/mypage/profile/phone',
  /** 내국인 비밀번호 변경 (PASS 본인인증 → 새 비밀번호). 사이드바 없는 단독 화면. */
  profilePassword: '/mypage/profile/password',
  /** 외국인 비밀번호 변경 (SMS 인증 → 새 비밀번호). */
  profilePasswordEn: '/mypage/profile/password/en',
  services: '/mypage/services',
  coupons: '/mypage/coupons',
  payments: '/mypage/payments',
  settings: '/mypage/settings',
  /** 회원 탈퇴 (범위 선택 → 계정 선택 → 사유 입력). 사이드바 없는 단독 화면. */
  leave: '/mypage/leave',
} as const;

export const MYPAGE_PASSWORD_CHANGE_RESULT_PARAM = 'passwordChange';
export const MYPAGE_PASSWORD_CHANGE_SUCCESS = 'success';

export function getMypagePasswordChangeSuccessHref() {
  return `${MYPAGE_ROUTES.profile}?${new URLSearchParams({
    [MYPAGE_PASSWORD_CHANGE_RESULT_PARAM]: MYPAGE_PASSWORD_CHANGE_SUCCESS,
  })}`;
}

/** LNB/사이드바 메뉴로 노출되는 라우트만. (root, 하위 상세 화면 제외) */
export type MypageMenuKey = Exclude<
  keyof typeof MYPAGE_ROUTES,
  | 'root'
  | 'profileVerify'
  | 'profilePhone'
  | 'profilePassword'
  | 'profilePasswordEn'
  | 'leave'
>;

export const MYPAGE_MENU_ITEMS: ReadonlyArray<{
  key: MypageMenuKey;
  label: string;
  href: (typeof MYPAGE_ROUTES)[MypageMenuKey];
}> = [
  { key: 'profile', label: '내 정보', href: MYPAGE_ROUTES.profile },
  { key: 'services', label: '내 서비스', href: MYPAGE_ROUTES.services },
  { key: 'coupons', label: '내 쿠폰', href: MYPAGE_ROUTES.coupons },
  { key: 'payments', label: '결제 내역', href: MYPAGE_ROUTES.payments },
  { key: 'settings', label: '설정', href: MYPAGE_ROUTES.settings },
];

export const MYPAGE_SERVICE_HISTORY_ROUTE = '/mypage/services/history';
export const MYPAGE_SHARED_OFFICE_DETAIL_ROUTE =
  '/mypage/services/shared-office';
export const MYPAGE_SHARED_OFFICE_MEMBERSHIP_HISTORY_SEGMENT =
  'membership-installments';
export const MYPAGE_LOUNGE_MEMBERSHIP_DETAIL_ROUTE =
  '/mypage/services/lounge-membership';

export const MYPAGE_SERVICE_TYPES = [
  'shared-office',
  'lounge-membership',
] as const;

export type MypageServiceType = (typeof MYPAGE_SERVICE_TYPES)[number];

export function parseMypageServiceType(
  value: string | string[] | undefined,
): MypageServiceType {
  return typeof value === 'string' &&
    MYPAGE_SERVICE_TYPES.includes(value as MypageServiceType)
    ? (value as MypageServiceType)
    : 'shared-office';
}

export function getMypageServiceHistoryHref(type: MypageServiceType) {
  return `${MYPAGE_SERVICE_HISTORY_ROUTE}?${new URLSearchParams({ type })}`;
}

export function getMypageLoungeMembershipDetailHref(contractId: number) {
  return `${MYPAGE_LOUNGE_MEMBERSHIP_DETAIL_ROUTE}/${contractId}`;
}

export function getMypageLoungeMembershipCancelCompleteHref(
  contractId: number,
) {
  return `${getMypageLoungeMembershipDetailHref(contractId)}/cancel-complete`;
}

export function getMypageLoungeMembershipSurveyHref(contractId: number) {
  return `${getMypageLoungeMembershipDetailHref(contractId)}/survey`;
}

export function getMypageSharedOfficeDetailHref(contractId: number) {
  return `${MYPAGE_SHARED_OFFICE_DETAIL_ROUTE}/${contractId}`;
}

export function getMypageSharedOfficeMembershipHistoryHref(contractId: number) {
  return `${getMypageSharedOfficeDetailHref(contractId)}/${MYPAGE_SHARED_OFFICE_MEMBERSHIP_HISTORY_SEGMENT}`;
}
